import { computed, ref, getCurrentInstance } from "vue-demi";
import { defineStore } from "pinia";

// Plugin
import moment from "moment";

export const usePageStore = defineStore("pageHeader", () => {
  const vm = getCurrentInstance().proxy;

  const pageTitle = ref("");
  const pageIcon = ref("");

  const hasActions = ref(false);
  const hasFullScreen = ref(false);
  const hasDownloadApi = ref(false);
  const hasDownload = ref(false);
  const hasDateRange = ref(false);
  const hasDateRangeAll = ref(false);

  const downloadData = ref([]);
  const downloadHeader = ref({});
  const isFullScreen = ref(false);

  const dateRange = ref({
    start: moment().subtract(1, "weeks").startOf("week").format("YYYY-MM-DD"),
    end: moment().subtract(1, "weeks").endOf("week").format("YYYY-MM-DD"),
    text: "Geçen Hafta",
    value: "lastWeek",
  });

  const tableHeight = computed(() => {
    let result = "80dvh";
    if (isFullScreen.value) {
      result = "calc(100dvh - 65px)";
    } else {
      if (vm.$vuetify.breakpoint.mdAndDown) {
        result = "calc(100dvh - 132px)";
      } else if (!vm.$vuetify.breakpoint.mdAndDown) {
        result = "calc(100dvh - 172px)";
      }
    }
    return result;
  });

  const pageSettingsClear = () => {
    pageTitle.value = "";
    pageIcon.value = "";

    hasActions.value = false;
    hasFullScreen.value = false;
    hasDownloadApi.value = false;
    hasDownload.value = false;
    hasDateRange.value = false;
    hasDateRangeAll.value = false;

    downloadData.value = [];
    downloadHeader.value = {};
    isFullScreen.value = false;
    dateRange.value = {
      start: moment().subtract(1, "weeks").startOf("week").format("YYYY-MM-DD"),
      end: moment().subtract(1, "weeks").endOf("week").format("YYYY-MM-DD"),
      text: "Geçen Hafta",
      value: "lastWeek",
    };
  };


  const orderStatusItems = [
    {
      text: 'Bekliyor',
      value: '1',
      color: 'warning',
      outlined: true,
    },
    {
      text: 'Ödeme Bekleniyor',
      value: '9',
      color: 'warning',
      outlined: true,
    },
    {
      text: 'Onaylandı',
      value: '2',
      color: 'success',
      outlined: true,
    },

    {
      text: 'İptal Edildi',
      value: '4',
      color: 'error',
      outlined: false,
    },
    {
      text: 'Limit Yetersiz',
      value: '5',
      color: 'error',
      outlined: true,
    },
    {
      text: 'Kart Bilgileri Yanlış',
      value: '6',
      color: 'error',
      outlined: false,
    },
    {
      text: 'Havale Bekleniyor',
      value: '7',
      color: 'warning',
      outlined: true,
    },
    {
      text: 'İletişim Bilgileri Yanlış',
      value: '8',
      color: 'warning',
      outlined: true,
    },
    {
      text: 'Siparişiniz kargoya verildi',
      value: '10',
      color: 'success',
      outlined: true,
    },
    {
      text: 'Siparişiniz Hazır, Teslim Alabilirsiniz',
      value: '16',
      color: 'success',
      outlined: false,
    },
    {
      text: 'Sipariş Teslim Edildi',
      value: '11',
      color: 'success',
      outlined: false,
    },
    {
      text: 'İade Edildi',
      value: '12',
      color: 'error',
      outlined: false,
    },
    {
      text: 'İade için onay bekliyor',
      value: '13',
      color: 'warning',
      outlined: true,
    },
    {
      text: 'Red Edildi',
      value: '15',
      color: 'tertiary',
      outlined: false,
    },
    {
      text: 'Kısmı Sevk',
      value: '97',
      color: 'warning',
      outlined: true,
    },

    {
      text: 'Aktarılamadı',
      value: '98',
      color: 'primary',
      outlined: false,
    },
  ];

  const objectFindValue = (items, value, select) => {
    const found = (items || []).find(item => String(item.value) === String(value));
    return found ? found[select] : undefined;
  };

  return {
    pageTitle,
    pageIcon,
    tableHeight,

    hasDateRange,
    hasDateRangeAll,
    dateRange,

    hasActions,
    hasDownloadApi,
    hasDownload,
    downloadData,
    downloadHeader,

    hasFullScreen,
    isFullScreen,
    orderStatusItems,
    objectFindValue,
    pageSettingsClear,
  };
});
